import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/views/sys/worker/create/Create.vue'
import DingtalkBindForm from '@/views/sys/worker/dingtalk-bind/DingtalkBind.vue'
import BatchSyncForm from '@/views/sys/worker/batch-sync/BatchSync.vue'
import { getWorkers, toggleSyncMaterial as toggleWorkerSync } from '@/api/worker'
import { getCorporations, getTeams, getKvData } from '@/api/open'
export default {
    name: 'workers',
    components: {
        CreateForm,
        DingtalkBindForm,
        BatchSyncForm,
        Layout,
    },
    data() {
        return {
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            corporations: [],
            teams: [],
            medias: [],
            selectedRowKeys: [],
            columns: [
                { title: '姓名', dataIndex: 'username', fixed: 'left' },
                { title: '别名', dataIndex: 'alias' },
                { title: 'ID', dataIndex: 'id' },
                { title: '所属主体', dataIndex: 'corporation_id', customRender: id => {
                    return this.$helper.getItemName(this.corporations, id) || '-'
                } },
                { title: '类型', dataIndex: 'type_name' },
                { title: '业务类型', dataIndex: 'business_type_name' },
                { title: '所属小组', dataIndex: 'teams' , scopedSlots: { customRender: 'teams' } },
                { title: '钉钉手机号', dataIndex: 'mobile' },
                { title: '巨量邮箱', dataIndex: 'juliang_emails' , scopedSlots: { customRender: 'emails' } },
                { title: '同步素材', dataIndex: '', scopedSlots: { customRender: 'is_sync_material' } },
                { title: '状态', dataIndex: 'state', fixed: 'right', scopedSlots: { customRender: 'state' } },
                { title: '操作', dataIndex: '', fixed: 'right', scopedSlots: {customRender: 'action'} }
            ],
            model: {},
            queryParam: {corporation_id:null},
            showForm:false,
            showDingtalkBindForm:false,
            showBatchSyncForm:false,
            emails: [],
            status: [{id:1, name:"在职"}, {id:2, name:"离职"}],
            businessTypes: [{id:1, name:"快手分销"}, {id:2, name:"快手番茄代投"}],
            types: [{id:1, name:"优化师"}, {id:2, name:"剪辑"}],
            syncOptions: [{id:0, name:"关闭"}, {id:1, name:"开启"}],
        }
    },
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: (keys) => {
                    this.selectedRowKeys = keys
                },
            }
        }
    },
    mounted() {
        getTeams().then(res=>{ this.teams = res.data.list || {} })
        getCorporations().then(res=>{ 
            this.corporations = res.data.list 
            if (this.corporations.length > 0) {
                // 主体默认设置为最后一个
                this.queryParam.corporation_id = this.corporations[this.corporations.length - 1].id
                this.getData()
            }
        })
    },
    methods: {
        create(record) {
            this.model = record.id ? Object.assign({}, record) :{
                type: 1,
                is_sync_material: false,
            }
            this.showForm = true
        },
        dingtalkBind(record) {
            this.model = Object.assign({}, record)
            this.showDingtalkBindForm = true
        },
        toggleSyncMaterial(record) {
            this.$confirm({
                title: `确认将优化师「${record.username}」的同步素材开关切换为 ${record.is_sync_material ? '关闭' : '开启'} 吗？`,
                onOk: () => {
                    return toggleWorkerSync({id: record.id}).then(() => {
                        this.$message.success('操作成功')
                        this.refresh()
                    })
                }
            })
        },
        batchSyncShow() {
            this.showBatchSyncForm = true
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        handleTableChange(pagination) {
            const pager = {...this.pagination}
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            getKvData({corporation_id:this.queryParam.corporation_id, type:5, flag:"getName"}).then(res=>{ this.emails = res.data.list || {} })

            const pagination = {...this.pagination}
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })
            getWorkers(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.selectedRowKeys = []
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        resetSearch() {
            this.selectedRowKeys = []
            this.queryParam = {corporation_id:this.corporations[this.corporations.length - 1].id}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('WorkerController', route)
        },
    }
}
